/**
 * Created by Tal on 7/13/17.
 */


import React from 'react'

const Footer = () => (
    <div className="footer">
        <p>
            Written by Tal Joffe
        </p>
    </div>
)

export default Footer


// WEBPACK FOOTER //
// ./src/components/Footer.js